import { h, render } from "preact";
import { defaultConfiguration } from "../shared/configuration";
import External from "../shared/controller/external-controller";
import Uploader from "./uploader";
import { IReactConfiguration } from "../typings";
import "./../media/assets/css/style.css";

export default class UploadYourLabel {
  uploader: External = null;
  afterLoadCallback: Function = null;
  private outsideClass: JSX.Element;

  constructor(dynamicConf: any = {}) {
    const endConf: IReactConfiguration = {
      ...defaultConfiguration,
      ...dynamicConf,
    };

    const root: HTMLElement = document.createElement("div");
    root.id = "js-label-uploader";
    document.body.querySelector(endConf.target).appendChild(root);

    this.outsideClass = render(
      <Uploader conf={endConf} outsideClass={this} />,
      root,
    );
  }

  _afterConfiguratorLoaded(configurator: External): void {
    this.uploader = configurator;

    if (this.afterLoadCallback) {
      if (typeof this.afterLoadCallback === "function") {
        this.afterLoadCallback();
      }
    }
  }

  onChange(callback: Function): void {
    this.uploader.addOnChangeCallback(callback);
  }

  afterLoad(callback: Function): void {
    this.afterLoadCallback = callback;

    if (this.uploader) {
      callback();
    }
  }

  exportAsJson(): string {
    return this.uploader.exportAsJson();
  }

  uploadImageAndExportAsJson(callback: (json: string) => void): void {
    this.uploader.uploadImageAndExportAsJson(callback);
  }

  clearCache(callback: (json: string) => void): void {
    this.uploader.clearCache();
  }

  isInputValid(): void {
    return this.uploader.isInputValid();
  }

  setMessage(message: string): void {
    // @ts-ignore
    return this.outsideClass._component.setMessage(message);
  }
}
